module.exports = __webpack_public_path__ + "static/img/bg_bottom@2x.577da09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb/bg_bottom@2x.png
// module id = Zgyj
// module chunks = 70